
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13323',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13323",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.897",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.10004",
  "foundations-components": "static-1.8568",
  "foundations-components-legacy": "static-1.1593",
  "foundations-theming": "static-1.4831",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.90",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8390",
  "hub-http-shared-msw-handlers": "static-1.10705",
  "hubspot-dlb": "static-2.1905",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11846",
  "I18n": "static-7.1681",
  "jasmine-runner": "static-1.6803",
  "marketplace-discovery-studio-lib": "static-1.719",
  "marketplace-storefront-base": "static-1.13386",
  "quartz": "static-1.7520",
  "react-dlb": "static-1.90",
  "react-rhumb": "static-1.17077",
  "reactive-variable-buffer-atom": "static-1.3208",
  "reporting-testing-lib": "static-1.10905",
  "reselect": "static-3.13",
  "settings-ui-lib": "static-1.12878",
  "SharedI18nStrings": "static-1.184",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7696",
  "ui-addon-i18n": "static-1.11501",
  "ui-addon-react-router-dom": "static-1.9886",
  "unified-auth": "static-1.1009",
  "unified-auth-core-lib": "static-1.1291",
  "usage-tracker": "static-1.7666",
  "usage-tracker-core": "static-1.7516",
  "customer-data-property-utils": "static-1.8446",
  "hub-http": "static-1.6566",
  "integrations-lib": "static-1.17169",
  "marketplace-ui-common": "static-1.20834",
  "marketplace-ui-install": "static-1.820",
  "property-management-iframe": "static-1.14231",
  "quartz-config": "static-1.1298",
  "quartz-core": "static-1.6739",
  "quartz-routing": "static-1.950",
  "quick-fetch": "static-1.4159",
  "react": "static-7.199",
  "rpc-client-utils": "static-1.5019",
  "ts-schema": "static-1.4328",
  "ui-universal-auth": "static-1.9495",
  "UIComponents": "static-3.8792",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3797",
  "quartz-webpack": "static-1.3744",
  "bend-plugin-quartz-routing": "static-1.598",
  "ai-components-ui-library": "static-1.9817",
  "codemirror": "static-5.103",
  "foundations-assets": "static-1.5240",
  "pulse": "static-1.985",
  "react-codemirror": "static-1.10997",
  "ui-extensions-preview-lib": "static-1.701",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4837",
  "floating-ui": "static-1.64",
  "foundations-theming-specialty": "static-1.2547",
  "framer-motion": "static-1.80",
  "hs-story-utils": "static-1.9778",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.80",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5591",
  "react-virtualized": "static-2.108",
  "StyleGuideUI": "static-3.509",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2770",
  "ui-fonts": "static-1.1108",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-theming": "static-1.3314",
  "foundations-theming-base": "static-1.3816",
  "stylex": "static-1.42",
  "HeadJS": "static-2.805",
  "hs-test-utils-bend-plugin": "static-1.3501",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4666",
  "ui-addon-video-player": "static-1.9050",
  "ai-rendering-library": "static-1.11189",
  "chirp-fetch": "static-1.2252",
  "connections-embed-lib": "static-1.1583",
  "copilot-toolkit": "static-1.11935",
  "feedback-loader": "static-1.29881",
  "laboratory-lib": "static-3.7507",
  "marketplace-embed": "static-1.23007",
  "marketplace-ui-details": "static-1.10729",
  "marketplace-ui-reviews": "static-1.20789",
  "marketplace-ui-tracking": "static-1.15004",
  "sanitize-text": "static-1.8512",
  "usage-tracker-multi": "static-1.6080",
  "usage-tracker-session-replay": "static-1.5352",
  "wootric-nps": "static-1.7232",
  "quartz-head": "static-1.1185",
  "web-vitals": "static-1.16",
  "apollo-link-hub-http": "static-2.5005",
  "immer": "static-1.102",
  "immerable": "static-1.4499",
  "highcharts": "static-8.112",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2724",
  "reporting-data": "static-1.68972",
  "cssUtils": "static-1.977",
  "flux-actions": "static-1.375",
  "react-colorpicker": "static-2.10568",
  "react-dnd-compat": "static-1.4969",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10725",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7656",
  "icons": "static-2.695",
  "marketplace-ui-apps-core": "static-1.19366",
  "storybook-react": "static-1.41",
  "trellis-story-utils": "static-1.4861",
  "foundations-components-test-utils": "static-1.6051",
  "quartz-i18n": "static-1.1195",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.558",
  "ads-unified-auth-lib": "static-1.1550",
  "custom-vendor-connection-lib": "static-1.59",
  "google-sheets-integration-lib": "static-1.1122",
  "microsoft-drive-auth-lib": "static-1.257",
  "surveymonkey-integration-lib": "static-1.596",
  "slack-ui-library": "static-1.10752",
  "fsm": "static-1.4107",
  "customer-data-objects": "static-1.8048",
  "property-translator": "static-1.5740",
  "hs-locale-management": "static-1.329",
  "frontend-preferences-client": "static-1.8274",
  "hs-promise-utils": "static-1.5944",
  "hubspot-apollo-client": "static-1.5230",
  "integrations-error-boundary-lib": "static-1.14584",
  "integrations-tracking-lib": "static-1.5965",
  "native-integrations-shared-strings": "static-1.8125",
  "sanitize": "static-1.4825",
  "superstore": "static-1.5114",
  "ui-shepherd-react": "static-3.10626",
  "ai-settings-ui-library": "static-1.8413",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4895",
  "immutable-less": "static-1.5005",
  "marketplace-ui-client-types": "static-1.18241",
  "nav-meta": "static-1.30562",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18446",
  "ui-product-approvals-common": "static-1.1223",
  "ai-studio-lib": "static-1.12514",
  "hubspot-prosemirror": "static-1.19072",
  "integrations-reconnect-lib": "static-1.556",
  "ui-addon-iframeable": "static-1.9431",
  "ui-addon-integrations-directory-panel": "static-2.8375",
  "ui-product-approvals": "static-1.29328",
  "ui-tool-access": "static-1.10509",
  "inbound-db-properties-service-client": "static-1.4082",
  "property-management-common": "static-1.6519",
  "opentelemetry-fe-types": "static-1.133",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.508",
  "quartz-auth": "static-1.1195",
  "quartz-test": "static-1.1195",
  "quartz-tracking": "static-1.899",
  "trellis-components": "static-1.2789",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.429",
  "HubStyle": "static-2.12153",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23267",
  "ContentUtils": "static-1.69226",
  "customer-data-objects-ui-components": "static-1.13385",
  "sassPrefix": "static-1.243",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.488",
  "batch-promise": "static-1.1899",
  "event-emitter": "static-1.1311",
  "fast-json-patch": "static-1.71",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5794",
  "magpie-types": "static-1.5254",
  "stylex-utils": "static-1.149",
  "trellis-theming": "static-1.1328",
  "avatar-components": "static-1.2838",
  "breeze-engine-core": "static-1.1150",
  "breeze-onboarding-components": "static-1.829",
  "customer-data-filters-ui": "static-1.41061",
  "customer-data-reference-ui-components": "static-1.13527",
  "embedded-academy-lib": "static-1.15680",
  "ExportDialog": "static-6.10733",
  "global-styles-ai-lib": "static-1.242",
  "highlight.js": "static-1.87",
  "marketplace-embed-ba": "static-1.710",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42156",
  "reporting-snowflake": "static-1.57588",
  "reporting-ui-components": "static-2.66241",
  "reporting-visualizations": "static-1.61046",
  "trial-components-library": "static-1.14191",
  "ui-addon-teams": "static-1.21960",
  "upgrade-components-lib": "static-1.584",
  "navigation-components": "static-1.18925",
  "breeze-engine-lib": "static-1.1872",
  "simple-logging-lib": "static-1.3404",
  "nudge-client-utils": "static-1.3222",
  "fail-safe": "static-1.310",
  "app-governance-lib": "static-1.2481",
  "developer-experience-shared-components": "static-1.10891",
  "purchase-motions-components": "static-1.6468",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10431",
  "usage-tracker-anonymous": "static-1.6083",
  "usage-tracker-public": "static-1.7477",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4056",
  "reference-resolvers": "static-1.8535",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4272",
  "hubspot-apollo-cache": "static-1.689",
  "universal-page-editor-lib": "static-1.3363",
  "final-form": "static-1.79",
  "redux-toolkit": "static-1.79",
  "simple-data-table": "static-1.3605",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5105",
  "content-assistance-lib": "static-1.8268",
  "content-media-capture": "static-1.5545",
  "customer-data-ui-utilities": "static-1.10186",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24610",
  "growth-payments-core": "static-1.26282",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3246",
  "payment-link-components": "static-1.24237",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20380",
  "ui-addon-emoji-picker": "static-1.10231",
  "ui-business-units-lib": "static-1.9446",
  "video-components-external": "static-1.12236",
  "video-data-lib": "static-1.35894",
  "navigation-messaging": "static-1.8252",
  "collaboration-sidebar": "static-1.58820",
  "crm-component-utils": "static-1.39940",
  "crm-properties-common-lib": "static-1.6243",
  "customer-data-properties": "static-1.52734",
  "external-options-client-types": "static-1.4375",
  "framework-data-schema-resolvers": "static-1.7249",
  "property-value-citations": "static-1.3348",
  "reference-resolvers-lite": "static-1.8457",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.59",
  "hubspotter-http-shared-msw-handlers": "static-1.10703",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "tanstack-virtual": "static-1.39",
  "cms-field-types": "static-1.5165",
  "content-icons-ui": "static-1.2410",
  "atom": "static-1.5435",
  "idb-keyval": "static-1.52",
  "reactive-lib": "static-1.1073",
  "breeze-artifacts-sdk": "static-1.519",
  "getting-started-shared-tasks": "static-1.19343",
  "onboarding-journeys-lib": "static-1.1031",
  "onboarding-scopes": "static-1.6806",
  "conversations-skeleton-state": "static-1.7596",
  "crm-message-bus": "static-1.43866",
  "customer-data-filters-ui-msw-helpers": "static-1.23496",
  "events-data-lib": "static-1.603",
  "FormUrlGenerator": "static-2.5074",
  "framework-builder-read-service-client": "static-1.4256",
  "hs-resources": "static-1.548",
  "multi-account-reference-resolvers": "static-1.1360",
  "onboarding-tours": "static-1.17209",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14555",
  "segments-client-types": "static-1.11708",
  "academy-common-lib": "static-1.15140",
  "dashboard-lib": "static-1.82986",
  "hubspot-prosemirror-plugins": "static-1.19064",
  "share-with-third-party-component-lib": "static-1.9064",
  "ui-asset-management-lib": "static-1.11458",
  "user-context": "static-1.5469",
  "reporting-plugins": "static-1.10827",
  "reporting-reports": "static-1.68648",
  "hubs-service-types": "static-1.1615",
  "purchase-motions-api": "static-1.6471",
  "salesImages": "static-1.615",
  "signup-constants": "static-1.19708",
  "nest": "static-1.590",
  "breeze-engine-chat-components": "static-1.850",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.2979",
  "nudge-renderer-utils": "static-1.3298",
  "whisper-core-api": "static-1.7420",
  "bend-plugin-fail-safe": "static-1.261",
  "framework-listing-lib": "static-2.29596",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31514",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4587",
  "signup-ui-url-generator": "static-2.8414",
  "onboarding-tours-client": "static-1.5424",
  "one-click-checkout": "static-1.522",
  "platform-infra-nav-components": "static-1.7928",
  "subscription-experience-data-types": "static-1.15295",
  "crm-record-cards-service-types": "static-1.3801",
  "location-customization-utils-lib": "static-1.10201",
  "redux-thunk": "static-2.81",
  "react-flip-move": "static-1.79",
  "ui-coaching-tips": "static-1.29400",
  "content-media-composition-data-lib": "static-1.13349",
  "fix-webm-duration": "static-1.31",
  "notification-sounds": "static-1.4779",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.808",
  "ui-addon-opt": "static-4.8714",
  "commerce-tours-lib": "static-1.6694",
  "growth-onboarding-reliability": "static-1.5435",
  "sales-checkout-service-client": "static-1.3884",
  "data-token-picker": "static-1.16958",
  "FileManagerLib": "static-1.40250",
  "content-media-compositions": "static-2.17356",
  "media-bridge-lib": "static-1.19476",
  "chatspot-widget-iframe": "static-1.23258",
  "collaboration-sidebar-common": "static-1.3617",
  "marketing-platform-lib": "static-1.7227",
  "card-properties-lib": "static-1.45105",
  "commerce-subscription-lib": "static-1.37881",
  "crm-actions": "static-1.6704",
  "crm-cards-sdk": "static-1.44702",
  "customer-data-properties-shared-msw-handlers": "static-1.10032",
  "customer-data-tracking": "static-1.7229",
  "calling-global-api": "static-1.65785",
  "calling-internal-common": "static-1.31675",
  "calling-lifecycle-internal": "static-1.67167",
  "calling-lifecycle-messages": "static-1.59461",
  "commerce-products-lib": "static-1.10644",
  "conditional-properties-service-client": "static-1.4051",
  "crm-index-visualization-core": "static-1.4600",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4382",
  "formula-editor": "static-1.14842",
  "google-libphonenumber": "static-1.46",
  "inbounddb-objects-service-types": "static-1.4459",
  "meetings-icalendar-utils-lib": "static-1.990",
  "multi-currency-client-types": "static-1.3942",
  "object-builder-ui-client": "static-1.49792",
  "pipeline-validation-client-types": "static-1.4217",
  "smart-data-capture-core": "static-1.224",
  "smart-property-lib": "static-1.8405",
  "tiered-pricing": "static-1.2040",
  "topics-actions-lib": "static-1.525",
  "ui-addon-form-validation": "static-1.11332",
  "zustand": "static-1.86",
  "fdsr-migration-layer": "static-1.368",
  "framework-data-schema-quick-fetch": "static-1.7154",
  "restore-request-side-panel-lib": "static-1.1769",
  "growth-data-modal": "static-1.5965",
  "growth-onboarding-confetti": "static-1.3420",
  "growth-onboarding-next-action-utils": "static-1.2781",
  "onboarding-tours-utils": "static-1.1276",
  "ui-shepherd-tracker": "static-1.8007",
  "crm-index-associations-lib": "static-1.6800",
  "academy-service-client": "static-1.4046",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40109",
  "SafeStorage": "static-1.4753",
  "video-embed": "static-1.36728",
  "redux-actions": "static-3.71",
  "EmailSignatureEditor": "static-1.25072",
  "viral-links-lib": "static-1.7429",
  "nested-table": "static-1.590",
  "timezone-utils": "static-2.5590",
  "getting-started-shared-tasks-store": "static-1.18461",
  "campaign-roi-lib": "static-1.10481",
  "campaigns-utils-lib": "static-1.3581",
  "ui-addon-calendars": "static-2.5700",
  "customer-data-views-management": "static-1.26120",
  "framework-data-table": "static-2.12639",
  "nudge-custom-ui-functions": "static-1.1572",
  "switchboard-lib": "static-1.575",
  "access-check-ui-lib": "static-1.1682",
  "app-users-service-client": "static-1.5975",
  "app-users-service-types": "static-1.5383",
  "mini-checkout-client": "static-1.27617",
  "onboarding-utils": "static-1.5725",
  "permissions-shared-i18n-strings-fe": "static-1.2130",
  "ui-coaching-tips-shared-config": "static-1.29385",
  "checkout-sdk": "static-3.24460",
  "payment-method-components": "static-1.7200",
  "touchless-buying-components": "static-1.6328",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.751",
  "growth-onboarding-feedback-components": "static-1.6939",
  "audio-components": "static-1.6414",
  "FileManagerImages": "static-1.37761",
  "video-components": "static-1.14238",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92949",
  "customer-data-sidebar": "static-2.46824",
  "enrichment-lib": "static-1.595",
  "ui-addon-draggable-compat": "static-2.4616",
  "universal-record-utils-lib": "static-1.2098",
  "commerce-billing-lib": "static-1.20309",
  "commerce-shared-components-lib": "static-1.19348",
  "commerce-tools-ui-lib": "static-1.11133",
  "crm-fe-perf": "static-1.23253",
  "calling-error-reporting": "static-1.31682",
  "shared-worker-versioning": "static-1.11395",
  "calling-usage-tracker": "static-1.6891",
  "voice-sms-access-library": "static-1.2166",
  "commerce-permissions": "static-1.1132",
  "products-iframe-lib": "static-1.8677",
  "products-ui-components-shared-msw-handlers": "static-1.11087",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10788",
  "sales-views-client-types": "static-1.4610",
  "bark-lib": "static-1.16871",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.721",
  "policy-lib": "static-1.7160",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10851",
  "onboarding-data-sync-lib": "static-1.2602",
  "growth-onboarding-next-action-components": "static-1.2809",
  "user-context-client": "static-1.4863",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4877",
  "outpost": "static-1.4499",
  "draft-convert": "static-2.81",
  "draft-extend": "static-3.84",
  "draft-js": "static-5.86",
  "draft-plugins": "static-2.22219",
  "sales-email-signature-service-client": "static-1.4202",
  "ts-utils-lib": "static-1.502",
  "copilot-messaging": "static-1.2185",
  "crm-export-dialog": "static-1.6638",
  "crm-index-ui-shimmer": "static-1.2773",
  "crm-view-components": "static-1.1293",
  "react-beautiful-dnd": "static-1.71",
  "customer-data-associations": "static-1.7684",
  "tasks-actions-lib": "static-1.231",
  "InboxConnectUtils": "static-4.15646",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46937",
  "hub-http-rxjs": "static-1.856",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4346",
  "company-details-components": "static-1.6560",
  "react-performance-metrics-lib": "static-1.908",
  "pricing-pages-ui-components": "static-1.16027",
  "quote-checkout-service-types": "static-1.3809",
  "social-insights-client-types": "static-1.22728",
  "crm_universal": "static-1.22555",
  "customer-data-email": "static-1.18583",
  "card-payment-highlight-lib": "static-1.38092",
  "commerce-contract-lib": "static-1.13496",
  "invoices-highlight-card-lib": "static-1.55879",
  "orders-highlight-card-lib": "static-1.22285",
  "products-highlight-card-lib": "static-1.18927",
  "quotes-highlight-card-lib": "static-1.72867",
  "crm-source-interpretation-lib": "static-1.5686",
  "data-agent-test-utils": "static-1.188",
  "data-agent-utils": "static-1.657",
  "crm-object-search-query-utilities": "static-1.10276",
  "utility-belt": "static-1.2887",
  "payments-enrollment-embed-lib": "static-1.23934",
  "stripe-embedded-components": "static-1.8066",
  "customer-data-rte": "static-1.33720",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6356",
  "payments-post-enroll-local-storage-lib": "static-1.5458",
  "qrcode-generator": "static-1.77",
  "quotes-client-types": "static-1.38957",
  "calling-orchestration-schema": "static-1.36943",
  "react-reducer-toolkit": "static-1.16454",
  "meetings-connect-utils-lib": "static-1.7966",
  "hub-http-contrib": "static-1.3387",
  "ui-addon-sales-email": "static-1.5561",
  "access-control-lib": "static-1.10784",
  "EmailComponents": "static-1.55641",
  "EmailData": "static-1.54319",
  "redux-less": "static-2.9823",
  "company-details-service-types": "static-1.4297",
  "segments-query-core": "static-1.1779",
  "pricing-pages-api": "static-1.15892",
  "sequences-lib": "static-1.8601",
  "ui-gdpr-components": "static-1.10644",
  "products-ui-components": "static-1.41162",
  "accounting-integrations-ui-components": "static-1.7608",
  "invoices-ui-lib": "static-1.55895",
  "commerce-products-api": "static-1.2751",
  "invoices-iframe-lib": "static-1.57953",
  "quotes-modal-lib": "static-1.103545",
  "quotes-ui-lib": "static-1.81588",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28978",
  "ContentComponents": "static-2.72182",
  "ContentData": "static-1.69301",
  "marketing-email-service-types": "static-1.2128",
  "messaging-editing-lib": "static-1.47251",
  "messaging-usage-based-billing-components-lib": "static-1.2113",
  "automation-ui-source-apps": "static-1.19776",
  "automation-ui-types": "static-1.20694",
  "messaging-types-lib": "static-1.46988",
  "onboarding-settings-client": "static-1.4863",
  "sequences-client-types-lib": "static-1.8458",
  "commerce-tax-lib": "static-1.894",
  "price-books-api": "static-1.1820",
  "price-books-components": "static-1.1878",
  "property-description-translator": "static-1.4183",
  "ramp-editor": "static-1.974",
  "commerce-analytics-service-client": "static-1.3872",
  "totals-ui-components": "static-1.24378",
  "SalesContentIndexUI": "static-3.9675",
  "advanced-menus-core": "static-1.15644",
  "advanced-menus-lib": "static-1.12506",
  "automation-ui-ubb": "static-1.6610",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7692",
  "data-token-views": "static-1.16939",
  "forms-utils-lib": "static-1.13159",
  "payments-embed-points-lib": "static-1.13667",
  "react-tinymce": "static-1.56068",
  "simple-menus-core": "static-1.15643",
  "simple-menus-lib": "static-1.17160",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55194",
  "tinymce-data": "static-1.41279",
  "tinymce-plugins": "static-1.58308",
  "tinymce-themes": "static-1.57164",
  "ui-brand-identity-lib": "static-1.16660",
  "ui-memberships-settings-lib": "static-1.34934",
  "videoconference-integration-components": "static-1.7361",
  "automation-applications-service-types": "static-1.3665",
  "automation-platform-service-types": "static-1.2676",
  "ContentEditorUI": "static-2.78010",
  "content-whatsapp-service-types": "static-1.584",
  "short-messages-app-service-client": "static-1.4274",
  "web-interactives-components": "static-1.14315",
  "web-interactives-data": "static-1.14316",
  "messaging-shared-utils-lib": "static-1.1562",
  "messaging-user-info-utils-lib": "static-1.1732",
  "email-portal-health-service-types": "static-1.1337",
  "line-items-api": "static-1.1160",
  "commerce-totals-service-types": "static-1.4067",
  "FireAlarmUi": "static-1.4756",
  "sales-templates-service-types-lib": "static-1.4419",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22630",
  "automation-ui-usage-tracking": "static-1.22093",
  "data-studio-ubb": "static-1.3599",
  "interframe": "static-3.5102",
  "layout-dnd-components": "static-1.13042",
  "layout-dnd-utils": "static-1.12017",
  "NamespacedHubStyle": "static-2.9295",
  "campaigns-lib": "static-1.27737",
  "content-management-data-lib": "static-1.6041",
  "copilot-plugins": "static-1.11907",
  "cta-picker": "static-1.37160",
  "customer-agent-discovery-components-lib": "static-1.4049",
  "editor-components": "static-1.13718",
  "editor-iframe-lib": "static-1.8856",
  "error-messaging-js": "static-1.5546",
  "FormsCommonComponents": "static-1.86659",
  "layout-data-lib": "static-1.10342",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.74",
  "redux-request-state": "static-1.10995",
  "SharedLegalStrings": "static-1.2089",
  "smart-content-core": "static-1.43262",
  "smart-content-lib": "static-1.43915",
  "social-composer-lib": "static-1.60382",
  "structured-content-lib": "static-1.26003",
  "theme-previewer-lib": "static-1.53996",
  "tinymce-copilot": "static-1.17262",
  "xray-recommendation-lib": "static-1.8323",
  "automation-ui-routing": "static-1.22051",
  "sql-reporting-client-types": "static-1.5932",
  "attribution-lib": "static-1.42863",
  "reporting-enablement": "static-1.23922",
  "forms-ai-lib": "static-1.4828",
  "codemirror-dlb": "static-1.59569",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6797",
  "report-customization-components": "static-1.13996",
  "data-quality-ui-library": "static-1.13971",
  "reporting-filters": "static-1.1083",
  "reporting-insights-lib": "static-1.2675",
  "merge-modal-lib": "static-1.12727"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13323",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.897",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.10004",
  "foundations-components": "/foundations-components/static-1.8568",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1593",
  "foundations-theming": "/foundations-theming/static-1.4831",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.90",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8390",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10705",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11846",
  "I18n": "/I18n/static-7.1681",
  "jasmine-runner": "/jasmine-runner/static-1.6803",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.719",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13386",
  "quartz": "/quartz/static-1.7520",
  "react-dlb": "/react-dlb/static-1.90",
  "react-rhumb": "/react-rhumb/static-1.17077",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3208",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10905",
  "reselect": "/reselect/static-3.13",
  "settings-ui-lib": "/settings-ui-lib/static-1.12878",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7696",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11501",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9886",
  "unified-auth": "/unified-auth/static-1.1009",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1291",
  "usage-tracker": "/usage-tracker/static-1.7666",
  "usage-tracker-core": "/usage-tracker-core/static-1.7516",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8446",
  "hub-http": "/hub-http/static-1.6566",
  "integrations-lib": "/integrations-lib/static-1.17169",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20834",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.820",
  "property-management-iframe": "/property-management-iframe/static-1.14231",
  "quartz-config": "/quartz-config/static-1.1298",
  "quartz-core": "/quartz-core/static-1.6739",
  "quartz-routing": "/quartz-routing/static-1.950",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "react": "/react/static-7.199",
  "rpc-client-utils": "/rpc-client-utils/static-1.5019",
  "ts-schema": "/ts-schema/static-1.4328",
  "ui-universal-auth": "/ui-universal-auth/static-1.9495",
  "UIComponents": "/UIComponents/static-3.8792",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3797",
  "quartz-webpack": "/quartz-webpack/static-1.3744",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.598",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9817",
  "codemirror": "/codemirror/static-5.103",
  "foundations-assets": "/foundations-assets/static-1.5240",
  "pulse": "/pulse/static-1.985",
  "react-codemirror": "/react-codemirror/static-1.10997",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.701",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4837",
  "floating-ui": "/floating-ui/static-1.64",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2547",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-story-utils": "/hs-story-utils/static-1.9778",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5591",
  "react-virtualized": "/react-virtualized/static-2.108",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2770",
  "ui-fonts": "/ui-fonts/static-1.1108",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3314",
  "foundations-theming-base": "/foundations-theming-base/static-1.3816",
  "stylex": "/stylex/static-1.42",
  "HeadJS": "/HeadJS/static-2.805",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3501",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4666",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9050",
  "ai-rendering-library": "/ai-rendering-library/static-1.11189",
  "chirp-fetch": "/chirp-fetch/static-1.2252",
  "connections-embed-lib": "/connections-embed-lib/static-1.1583",
  "copilot-toolkit": "/copilot-toolkit/static-1.11935",
  "feedback-loader": "/feedback-loader/static-1.29881",
  "laboratory-lib": "/laboratory-lib/static-3.7507",
  "marketplace-embed": "/marketplace-embed/static-1.23007",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10729",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20789",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15004",
  "sanitize-text": "/sanitize-text/static-1.8512",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6080",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5352",
  "wootric-nps": "/wootric-nps/static-1.7232",
  "quartz-head": "/quartz-head/static-1.1185",
  "web-vitals": "/web-vitals/static-1.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5005",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4499",
  "highcharts": "/highcharts/static-8.112",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2724",
  "reporting-data": "/reporting-data/static-1.68972",
  "cssUtils": "/cssUtils/static-1.977",
  "flux-actions": "/flux-actions/static-1.375",
  "react-colorpicker": "/react-colorpicker/static-2.10568",
  "react-dnd-compat": "/react-dnd-compat/static-1.4969",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10725",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7656",
  "icons": "/icons/static-2.695",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19366",
  "storybook-react": "/storybook-react/static-1.41",
  "trellis-story-utils": "/trellis-story-utils/static-1.4861",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6051",
  "quartz-i18n": "/quartz-i18n/static-1.1195",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.558",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1550",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.59",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1122",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.257",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.596",
  "slack-ui-library": "/slack-ui-library/static-1.10752",
  "fsm": "/fsm/static-1.4107",
  "customer-data-objects": "/customer-data-objects/static-1.8048",
  "property-translator": "/property-translator/static-1.5740",
  "hs-locale-management": "/hs-locale-management/static-1.329",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8274",
  "hs-promise-utils": "/hs-promise-utils/static-1.5944",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5230",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14584",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5965",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8125",
  "sanitize": "/sanitize/static-1.4825",
  "superstore": "/superstore/static-1.5114",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10626",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8413",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "immutable-less": "/immutable-less/static-1.5005",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18241",
  "nav-meta": "/nav-meta/static-1.30562",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18446",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1223",
  "ai-studio-lib": "/ai-studio-lib/static-1.12514",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19072",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.556",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9431",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8375",
  "ui-product-approvals": "/ui-product-approvals/static-1.29328",
  "ui-tool-access": "/ui-tool-access/static-1.10509",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4082",
  "property-management-common": "/property-management-common/static-1.6519",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.133",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.508",
  "quartz-auth": "/quartz-auth/static-1.1195",
  "quartz-test": "/quartz-test/static-1.1195",
  "quartz-tracking": "/quartz-tracking/static-1.899",
  "trellis-components": "/trellis-components/static-1.2789",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.429",
  "HubStyle": "/HubStyle/static-2.12153",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23267",
  "ContentUtils": "/ContentUtils/static-1.69226",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13385",
  "sassPrefix": "/sassPrefix/static-1.243",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.488",
  "batch-promise": "/batch-promise/static-1.1899",
  "event-emitter": "/event-emitter/static-1.1311",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5794",
  "magpie-types": "/magpie-types/static-1.5254",
  "stylex-utils": "/stylex-utils/static-1.149",
  "trellis-theming": "/trellis-theming/static-1.1328",
  "avatar-components": "/avatar-components/static-1.2838",
  "breeze-engine-core": "/breeze-engine-core/static-1.1150",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.829",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41061",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13527",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15680",
  "ExportDialog": "/ExportDialog/static-6.10733",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.242",
  "highlight.js": "/highlight.js/static-1.87",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.710",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42156",
  "reporting-snowflake": "/reporting-snowflake/static-1.57588",
  "reporting-ui-components": "/reporting-ui-components/static-2.66241",
  "reporting-visualizations": "/reporting-visualizations/static-1.61046",
  "trial-components-library": "/trial-components-library/static-1.14191",
  "ui-addon-teams": "/ui-addon-teams/static-1.21960",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.584",
  "navigation-components": "/navigation-components/static-1.18925",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1872",
  "simple-logging-lib": "/simple-logging-lib/static-1.3404",
  "nudge-client-utils": "/nudge-client-utils/static-1.3222",
  "fail-safe": "/fail-safe/static-1.310",
  "app-governance-lib": "/app-governance-lib/static-1.2481",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10891",
  "purchase-motions-components": "/purchase-motions-components/static-1.6468",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10431",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6083",
  "usage-tracker-public": "/usage-tracker-public/static-1.7477",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4056",
  "reference-resolvers": "/reference-resolvers/static-1.8535",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4272",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.689",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3363",
  "final-form": "/final-form/static-1.79",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "simple-data-table": "/simple-data-table/static-1.3605",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8268",
  "content-media-capture": "/content-media-capture/static-1.5545",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10186",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24610",
  "growth-payments-core": "/growth-payments-core/static-1.26282",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3246",
  "payment-link-components": "/payment-link-components/static-1.24237",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20380",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9446",
  "video-components-external": "/video-components-external/static-1.12236",
  "video-data-lib": "/video-data-lib/static-1.35894",
  "navigation-messaging": "/navigation-messaging/static-1.8252",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58820",
  "crm-component-utils": "/crm-component-utils/static-1.39940",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6243",
  "customer-data-properties": "/customer-data-properties/static-1.52734",
  "external-options-client-types": "/external-options-client-types/static-1.4375",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7249",
  "property-value-citations": "/property-value-citations/static-1.3348",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8457",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.59",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10703",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "cms-field-types": "/cms-field-types/static-1.5165",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "atom": "/atom/static-1.5435",
  "idb-keyval": "/idb-keyval/static-1.52",
  "reactive-lib": "/reactive-lib/static-1.1073",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.519",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19343",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1031",
  "onboarding-scopes": "/onboarding-scopes/static-1.6806",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
  "crm-message-bus": "/crm-message-bus/static-1.43866",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23496",
  "events-data-lib": "/events-data-lib/static-1.603",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5074",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4256",
  "hs-resources": "/hs-resources/static-1.548",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1360",
  "onboarding-tours": "/onboarding-tours/static-1.17209",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14555",
  "segments-client-types": "/segments-client-types/static-1.11708",
  "academy-common-lib": "/academy-common-lib/static-1.15140",
  "dashboard-lib": "/dashboard-lib/static-1.82986",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19064",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9064",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11458",
  "user-context": "/user-context/static-1.5469",
  "reporting-plugins": "/reporting-plugins/static-1.10827",
  "reporting-reports": "/reporting-reports/static-1.68648",
  "hubs-service-types": "/hubs-service-types/static-1.1615",
  "purchase-motions-api": "/purchase-motions-api/static-1.6471",
  "salesImages": "/salesImages/static-1.615",
  "signup-constants": "/signup-constants/static-1.19708",
  "nest": "/nest/static-1.590",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.850",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2979",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3298",
  "whisper-core-api": "/whisper-core-api/static-1.7420",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.261",
  "framework-listing-lib": "/framework-listing-lib/static-2.29596",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31514",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4587",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8414",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5424",
  "one-click-checkout": "/one-click-checkout/static-1.522",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7928",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15295",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3801",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10201",
  "redux-thunk": "/redux-thunk/static-2.81",
  "react-flip-move": "/react-flip-move/static-1.79",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29400",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13349",
  "fix-webm-duration": "/fix-webm-duration/static-1.31",
  "notification-sounds": "/notification-sounds/static-1.4779",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.808",
  "ui-addon-opt": "/ui-addon-opt/static-4.8714",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6694",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5435",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3884",
  "data-token-picker": "/data-token-picker/static-1.16958",
  "FileManagerLib": "/FileManagerLib/static-1.40250",
  "content-media-compositions": "/content-media-compositions/static-2.17356",
  "media-bridge-lib": "/media-bridge-lib/static-1.19476",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23258",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3617",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7227",
  "card-properties-lib": "/card-properties-lib/static-1.45105",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37881",
  "crm-actions": "/crm-actions/static-1.6704",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44702",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10032",
  "customer-data-tracking": "/customer-data-tracking/static-1.7229",
  "calling-global-api": "/calling-global-api/static-1.65785",
  "calling-internal-common": "/calling-internal-common/static-1.31675",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67167",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59461",
  "commerce-products-lib": "/commerce-products-lib/static-1.10644",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4051",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4600",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4382",
  "formula-editor": "/formula-editor/static-1.14842",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4459",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.990",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3942",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49792",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4217",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.224",
  "smart-property-lib": "/smart-property-lib/static-1.8405",
  "tiered-pricing": "/tiered-pricing/static-1.2040",
  "topics-actions-lib": "/topics-actions-lib/static-1.525",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
  "zustand": "/zustand/static-1.86",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.368",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7154",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1769",
  "growth-data-modal": "/growth-data-modal/static-1.5965",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3420",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2781",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1276",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8007",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6800",
  "academy-service-client": "/academy-service-client/static-1.4046",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40109",
  "SafeStorage": "/SafeStorage/static-1.4753",
  "video-embed": "/video-embed/static-1.36728",
  "redux-actions": "/redux-actions/static-3.71",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25072",
  "viral-links-lib": "/viral-links-lib/static-1.7429",
  "nested-table": "/nested-table/static-1.590",
  "timezone-utils": "/timezone-utils/static-2.5590",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18461",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10481",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3581",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5700",
  "customer-data-views-management": "/customer-data-views-management/static-1.26120",
  "framework-data-table": "/framework-data-table/static-2.12639",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1572",
  "switchboard-lib": "/switchboard-lib/static-1.575",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1682",
  "app-users-service-client": "/app-users-service-client/static-1.5975",
  "app-users-service-types": "/app-users-service-types/static-1.5383",
  "mini-checkout-client": "/mini-checkout-client/static-1.27617",
  "onboarding-utils": "/onboarding-utils/static-1.5725",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2130",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29385",
  "checkout-sdk": "/checkout-sdk/static-3.24460",
  "payment-method-components": "/payment-method-components/static-1.7200",
  "touchless-buying-components": "/touchless-buying-components/static-1.6328",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.751",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6939",
  "audio-components": "/audio-components/static-1.6414",
  "FileManagerImages": "/FileManagerImages/static-1.37761",
  "video-components": "/video-components/static-1.14238",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92949",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46824",
  "enrichment-lib": "/enrichment-lib/static-1.595",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4616",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2098",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20309",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19348",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11133",
  "crm-fe-perf": "/crm-fe-perf/static-1.23253",
  "calling-error-reporting": "/calling-error-reporting/static-1.31682",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11395",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6891",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2166",
  "commerce-permissions": "/commerce-permissions/static-1.1132",
  "products-iframe-lib": "/products-iframe-lib/static-1.8677",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11087",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10788",
  "sales-views-client-types": "/sales-views-client-types/static-1.4610",
  "bark-lib": "/bark-lib/static-1.16871",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.721",
  "policy-lib": "/policy-lib/static-1.7160",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10851",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2602",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2809",
  "user-context-client": "/user-context-client/static-1.4863",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4877",
  "outpost": "/outpost/static-1.4499",
  "draft-convert": "/draft-convert/static-2.81",
  "draft-extend": "/draft-extend/static-3.84",
  "draft-js": "/draft-js/static-5.86",
  "draft-plugins": "/draft-plugins/static-2.22219",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4202",
  "ts-utils-lib": "/ts-utils-lib/static-1.502",
  "copilot-messaging": "/copilot-messaging/static-1.2185",
  "crm-export-dialog": "/crm-export-dialog/static-1.6638",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2773",
  "crm-view-components": "/crm-view-components/static-1.1293",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.71",
  "customer-data-associations": "/customer-data-associations/static-1.7684",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.231",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15646",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46937",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.856",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4346",
  "company-details-components": "/company-details-components/static-1.6560",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.908",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16027",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3809",
  "social-insights-client-types": "/social-insights-client-types/static-1.22728",
  "crm_universal": "/crm_universal/static-1.22555",
  "customer-data-email": "/customer-data-email/static-1.18583",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38092",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13496",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55879",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22285",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18927",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72867",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5686",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.188",
  "data-agent-utils": "/data-agent-utils/static-1.657",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10276",
  "utility-belt": "/utility-belt/static-1.2887",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23934",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8066",
  "customer-data-rte": "/customer-data-rte/static-1.33720",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6356",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5458",
  "qrcode-generator": "/qrcode-generator/static-1.77",
  "quotes-client-types": "/quotes-client-types/static-1.38957",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36943",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16454",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7966",
  "hub-http-contrib": "/hub-http-contrib/static-1.3387",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5561",
  "access-control-lib": "/access-control-lib/static-1.10784",
  "EmailComponents": "/EmailComponents/static-1.55641",
  "EmailData": "/EmailData/static-1.54319",
  "redux-less": "/redux-less/static-2.9823",
  "company-details-service-types": "/company-details-service-types/static-1.4297",
  "segments-query-core": "/segments-query-core/static-1.1779",
  "pricing-pages-api": "/pricing-pages-api/static-1.15892",
  "sequences-lib": "/sequences-lib/static-1.8601",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10644",
  "products-ui-components": "/products-ui-components/static-1.41162",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7608",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55895",
  "commerce-products-api": "/commerce-products-api/static-1.2751",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57953",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103545",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81588",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28978",
  "ContentComponents": "/ContentComponents/static-2.72182",
  "ContentData": "/ContentData/static-1.69301",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2128",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47251",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2113",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19776",
  "automation-ui-types": "/automation-ui-types/static-1.20694",
  "messaging-types-lib": "/messaging-types-lib/static-1.46988",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4863",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8458",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.894",
  "price-books-api": "/price-books-api/static-1.1820",
  "price-books-components": "/price-books-components/static-1.1878",
  "property-description-translator": "/property-description-translator/static-1.4183",
  "ramp-editor": "/ramp-editor/static-1.974",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3872",
  "totals-ui-components": "/totals-ui-components/static-1.24378",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9675",
  "advanced-menus-core": "/advanced-menus-core/static-1.15644",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12506",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6610",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7692",
  "data-token-views": "/data-token-views/static-1.16939",
  "forms-utils-lib": "/forms-utils-lib/static-1.13159",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13667",
  "react-tinymce": "/react-tinymce/static-1.56068",
  "simple-menus-core": "/simple-menus-core/static-1.15643",
  "simple-menus-lib": "/simple-menus-lib/static-1.17160",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55194",
  "tinymce-data": "/tinymce-data/static-1.41279",
  "tinymce-plugins": "/tinymce-plugins/static-1.58308",
  "tinymce-themes": "/tinymce-themes/static-1.57164",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16660",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34934",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7361",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3665",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2676",
  "ContentEditorUI": "/ContentEditorUI/static-2.78010",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.584",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4274",
  "web-interactives-components": "/web-interactives-components/static-1.14315",
  "web-interactives-data": "/web-interactives-data/static-1.14316",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1562",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1732",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1337",
  "line-items-api": "/line-items-api/static-1.1160",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4067",
  "FireAlarmUi": "/FireAlarmUi/static-1.4756",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4419",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22630",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22093",
  "data-studio-ubb": "/data-studio-ubb/static-1.3599",
  "interframe": "/interframe/static-3.5102",
  "layout-dnd-components": "/layout-dnd-components/static-1.13042",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12017",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9295",
  "campaigns-lib": "/campaigns-lib/static-1.27737",
  "content-management-data-lib": "/content-management-data-lib/static-1.6041",
  "copilot-plugins": "/copilot-plugins/static-1.11907",
  "cta-picker": "/cta-picker/static-1.37160",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4049",
  "editor-components": "/editor-components/static-1.13718",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8856",
  "error-messaging-js": "/error-messaging-js/static-1.5546",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86659",
  "layout-data-lib": "/layout-data-lib/static-1.10342",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.74",
  "redux-request-state": "/redux-request-state/static-1.10995",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2089",
  "smart-content-core": "/smart-content-core/static-1.43262",
  "smart-content-lib": "/smart-content-lib/static-1.43915",
  "social-composer-lib": "/social-composer-lib/static-1.60382",
  "structured-content-lib": "/structured-content-lib/static-1.26003",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53996",
  "tinymce-copilot": "/tinymce-copilot/static-1.17262",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8323",
  "automation-ui-routing": "/automation-ui-routing/static-1.22051",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5932",
  "attribution-lib": "/attribution-lib/static-1.42863",
  "reporting-enablement": "/reporting-enablement/static-1.23922",
  "forms-ai-lib": "/forms-ai-lib/static-1.4828",
  "codemirror-dlb": "/codemirror-dlb/static-1.59569",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6797",
  "report-customization-components": "/report-customization-components/static-1.13996",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13971",
  "reporting-filters": "/reporting-filters/static-1.1083",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2675",
  "merge-modal-lib": "/merge-modal-lib/static-1.12727"
}
};
